import React, { Component } from 'react';
import { Button, withStyles } from '@material-ui/core';
import styled, { keyframes } from 'styled-components';
import { withTranslation } from 'react-i18next';
import { faCopy, faPen, faTrash, faBookOpen, faArchive } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isIE, isEdge } from '../../../../common/utilities/browserDetection';
import { getHyperfindLabel } from '../../../utils';

import { AdminSidePanelActionNames, getRequestTypeLabel, getRequestSubTypeLabel } from '../../../Enums';

import { Popover, Whisper } from 'rsuite';
import { Typography, List, ListItem, ListItemText, Divider, makeStyles } from '@material-ui/core';
import { AdminDetailsTooltip } from "./AdminDetailsTooltip"

import { WarningIconWithTooltip } from '../../../../common-client2/src/components';

const styles = () => ({
	green: {
		color: 'green',
	},
	red: {
		color: 'red',
	},
	darkorange: {
		color: 'darkorange',
	},
	name: {
		width: '15%',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		color: '#3A3A3A',
	},
	description: {
		width: '15%',
		color: '#3A3A3A',
	},
	warning: {
		width: '10%',
		color: '#3A3A3A',
	},
	requestType: {
		width: '10%',
		color: '#3A3A3A',
	},
	requestSubtype: {
		width: '10%',
		color: '#3A3A3A',
	},
	creationHyperFindQuery: {
		width: '15%',
		clear: 'both',
		display: 'flex',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		color: '#3A3A3A',
		alignItems: 'end',
	},
	managementHyperFindQuery: {
		width: '15%',
		clear: 'both',
		display: 'flex',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		color: '#3A3A3A',
		alignItems: 'end',
	},
	approvalProcess: {
        width: '10%',
        clear: 'both',
        display: 'flex',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3A3A3A',
        alignItems: 'end',
    },
	fontAwesomeIcon: {
		margin: '7px'
	},
	buttonsAction: {
		textTransform: 'initial',
		color: '#767676',
		padding: '0px'
	},
	namefontWeigth: {
		fontWeight: 600
	},
	quotaItemStyling: {
		height: '50px',
		margin: 0,
		width: '100%',
		'&:hover': {
			backgroundColor: '#f7f9fc'
		}
	},
	buttonSection: {
		position: 'absolute',
		right: '0',
		backgroundColor: '#f7f9fc',
		borderLeft: '1px solid lightgray',
		flex: '1 20 100%',
		paddingLeft: '5px',
		paddingRight: '5px',
	},
	adjustment: {
		top: '10px'
	}

});

const leftMove = keyframes`
  0% {
    opacity: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    transform : translateX(0px);
  }
`
const growing = keyframes`
  0% {
    opacity: 0;
    flex: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    flex: 1;
    transform : translateX(0px);
  }
`
const RowItem = styled.div`
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  position: relative;
  align-items: center;
  display: flex;
  animation: ${leftMove} ${props => 200 + (props.index * 40)}ms linear;
  border-radius: 5px;
  padding: 0;
`

const ItemTitle = styled.div`
  padding: 0 5px;
  flex: 0 0 auto;
`
const Buttons = styled.div`
  position: relatice;
  display: flex;
  animation: ${growing} 200ms linear;
`

class ConfigurationSetTableRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showButtons: false,
		};
	}

	getApprovalLabel = (isAutoApproval) => {
		return isAutoApproval
			? this.props.t('form.autoApproval')
			: this.props.t('form.manualApproval')
	}

	showButtonsHandler = (state) => {
		this.setState({ showButtons: state })
	}

	dotsContainer = () => {
		return <div></div>
	}

	buttonsHandler = (e, action) => {
		e.stopPropagation();
		this.props.showRightPanel(action, this.props.item)
	}

	buttonsContainer = (classes) => {
		let { t, item: { isUsedAdminSetting }, isEditable, isDeletable } = this.props;

		return (
			<Buttons>
				{ isEditable
				? (
					<Button
						className={classes.buttonsAction}
						onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Edit) }}
					>
						<FontAwesomeIcon
							className={classes.fontAwesomeIcon}
							icon={faPen} />
						{t('settings.edit')}
					</Button>)
				: (
					<Button
						className={classes.buttonsAction}
						onClick={(e) => { this.buttonsHandler(e, t('settings.view')) }}
					>
						<FontAwesomeIcon
							className={classes.fontAwesomeIcon}
							icon={faBookOpen} />
						{t('settings.view')}
					</Button>
				)}
				<Button
					className={classes.buttonsAction}
					onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Duplicate) }}
				>
					<FontAwesomeIcon
						className={classes.fontAwesomeIcon}
						icon={faCopy}
					/>
					{t('settings.duplicate')}
				</Button>
				{
					!isUsedAdminSetting
						? (
							isDeletable && (
								<Button
									className={classes.buttonsAction}
									onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Delete) }}
									// title={t('settings.deletable')} // TODO D. 23-10-05 (when FE Refactor)
								>
									<FontAwesomeIcon
										className={classes.fontAwesomeIcon}
										icon={faTrash}
									/>
									{t('settings.delete')}
								</Button>)
						)
						: (
							<Button
								className={classes.buttonsAction}
								onClick={(e) => {
									this.buttonsHandler(e, AdminSidePanelActionNames.Archive);
								}}
								// title={t('settings.archivable')} // TODO D. 23-10-05 (when FE Refactor)
							>
								<FontAwesomeIcon
									className={classes.fontAwesomeIcon}
									icon={faArchive}
								/>
								{t('settings.archive')}
							</Button>
						)
				}
			</Buttons>)
	}

	render() {
		const { classes, item, index, hyperFindList, t } = this.props;
		let buttonsSection = !this.state.showButtons ? this.dotsContainer() : this.buttonsContainer(classes);
		let description = (item.description.length > 30) ? item.description.substring(0, 27) + "..." : item.description;
		const warnings = item.warnings?.map(x => t(`admin.warnings.${x}`));

		return (
			<RowItem
				index={index}
				className={classes.quotaItemStyling}
				onMouseOver={() => { this.showButtonsHandler(true) }}
				onMouseLeave={() => { this.showButtonsHandler(false) }}>
				<ItemTitle className={classes.name}>
					<AdminDetailsTooltip data={item} translate={ "AdminRequestSetup."}>
						<div className={classes.namefontWeigth} style={{ display: 'inline-block', width: 'fit-content' }}>
							{item.name}
						</div>
					</AdminDetailsTooltip>
				</ItemTitle>
				<ItemTitle className={classes.warning}>
					{(!!warnings && !!warnings.length) ? <WarningIconWithTooltip tooltipWarnings={warnings}/> : <></>}
				</ItemTitle>
				<ItemTitle className={classes.description}>
					{description}
				</ItemTitle>
				<ItemTitle className={classes.approvalProcess}>
					{item.autoApproval ? t(`settings.autoApproval`) : t(`settings.manualApproval`)}
				</ItemTitle>
				<ItemTitle className={classes.requestType}>
					{getRequestTypeLabel(item.actionType)}
				</ItemTitle>
				<ItemTitle className={classes.requestSubtype}>
					{getRequestSubTypeLabel(item.actionType, item.requestSubtype)}
				</ItemTitle>
				<ItemTitle className={classes.creationHyperFindQuery}>
					{getHyperfindLabel(item.creationHyperfindId, hyperFindList)}
				</ItemTitle>
				<ItemTitle className={classes.managementHyperFindQuery}>
					{getHyperfindLabel(item.managementHyperfindId, hyperFindList)}
				</ItemTitle>
				<div className={[classes.buttonSection, (isIE() || isEdge()) ? classes.adjustment : ''].join(' ')}>
					{buttonsSection}
				</div>
			</RowItem>
		)
	}
}

export default withTranslation('employmentBillboard')(withStyles(styles)(ConfigurationSetTableRow));